import { getDecodedJWT } from '@/util/jwt_helper'

export const isSupportUser = (jwt: string | undefined): boolean => {
  if (!jwt) return false
  const decodedJwt = getDecodedJWT(jwt)
  if (!decodedJwt) return false
  return !!(decodedJwt?.supportAgentId || decodedJwt?.appMeta?.supportAgentId)
} 